module.exports = __webpack_public_path__ + "static/pearson-00-hero-cb73376130f354c06ec454d79200ac24.jpg";